import { NextPage } from 'next';
import { GetStaticProps } from 'next';
import AudioBooks from '@/components/screens/audio-books/AudioBooks';
import { BOOKS_FOR_PAGE, API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import { IBooksPage } from '@/interfaces/booksPage.interface';

const NewPage: NextPage<IBooksPage> = ({ books }) => {
  return <AudioBooks books={books} />;
};

export const getStaticProps: GetStaticProps = async () => {
  const res = await fetch(`${API_URL}satellite/books?book_type=audio_book&page=1&page_size=${BOOKS_FOR_PAGE}&sort_reversed=false`);
  const books = await res.json();

  return {
    props: { books },
    revalidate: REVALIDATE_TIME,
  };
};

export default NewPage;
